import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { SonnerProvider } from '@/components/sonner-provider'
import '@/lib/i18n'
import './index.css'
import { router } from './router'
import { initAnalytics } from '@/lib/analytics'

import { ErrorBoundary } from '@/components/error-boundary'
import { reloadForChunkError } from '@/lib/chunk-recovery'

// Never cancel this event: Vite must reject the import so the router can
// display its error UI even when automatic recovery has already been used.
window.addEventListener('vite:preloadError', () => {
  reloadForChunkError()
})

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
})

// PostHog: init prima del render così cattura attribuzione (cid/utm dall'URL)
// e identifica la persona prima dei primi eventi del funnel.
try {
  initAnalytics()
} catch {
  // Optional analytics must never prevent the application from mounting.
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <SonnerProvider />
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
)
